
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claim-token",
      function () {
        return require("private-next-pages/claim-token.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claim-token"])
      });
    }
  